/* eslint-disable max-lines-per-function */
import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import classNames from 'clsx';
import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { isCurrentDarkTheme } from 'reactApp/modules/theme/theme.selectors';
import { MobileDialog } from 'reactApp/ui/Mobile/MobileDialog/MobileDialog';

import { EXTEND_QUOTA_OFFER_PROPS_MAP } from './ExtendQuotaOfferModal.const';
import styles from './ExtendQuotaOfferModal.css';
import { getExtendQuotaOfferModalCoverImage } from './ExtendQuotaOfferModal.helpers';
import type { ExtendQuotaOfferModalProps } from './ExtendQuotaOfferModal.types';

export const ExtendQuotaOfferMobileModal = memo<ExtendQuotaOfferModalProps>(
    ({ onShow, onPrimaryClick, onSecondaryClick, onClose, onCancel }) => {
        useEffect(onShow, []);

        const isDarkTheme = useSelector(isCurrentDarkTheme);

        const { title, text, primaryActionText, secondaryActionText } = EXTEND_QUOTA_OFFER_PROPS_MAP;

        const coverUrl = getExtendQuotaOfferModalCoverImage();

        return (
            <MobileDialog
                id={'extend-quota-offer-modal-mobile'}
                className={classNames(styles.root_mobile, styles.dialogContent)}
                onClose={() => {
                    // здесь это одно и то же, так как action-кнопки прокидываются извне
                    onCancel?.();
                    onClose();
                }}
                mod="base"
                topmost
                closeOnDimmerClick
                contextPadding="zero"
                innerClassNames={{
                    close: !isDarkTheme ? styles.close_dark : styles.close_light,
                }}
            >
                <div className={styles.imageWrapper}>
                    <img className={styles.image} src={coverUrl} alt="Cover image" />
                </div>
                <div className={styles.content}>
                    <Title level="1" className={styles.title}>
                        {title}
                    </Title>
                    <Spacing size={12} />
                    <Text className={styles.text}>{text}</Text>
                    {primaryActionText && (
                        <>
                            <Spacing size={24} />
                            <Button
                                className={styles.button}
                                mode="primary"
                                appearance="accent-invariable"
                                target="_blank"
                                onClick={onPrimaryClick}
                                stretched
                                size="l"
                            >
                                <div className={styles.buttonText}>{primaryActionText}</div>
                            </Button>
                        </>
                    )}
                    {secondaryActionText && (
                        <>
                            <Spacing size={8} />
                            <Button
                                className={styles.button}
                                mode="tertiary"
                                appearance="accent-invariable"
                                target="_blank"
                                onClick={onSecondaryClick}
                                stretched
                                size="l"
                            >
                                <div className={styles.buttonText}>{secondaryActionText}</div>
                            </Button>
                        </>
                    )}
                    <Spacing size={16} />
                </div>
            </MobileDialog>
        );
    }
);

ExtendQuotaOfferMobileModal.displayName = 'ExtendQuotaOfferMobileModal';
